import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const patientOptionsService = {
  basePath: `${clinicalApiPath}/patient-options`,

  getDiagnosisData() {
    return viperApi.get(this.basePath + '/diagnoses')
  },

  getDemographicsData() {
    return viperApi.get(this.basePath + '/demographics')
  }
}
